import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Form, Button, Table, Badge, Alert } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { fetchOptionChain } from '../slices/optionChainSlice';
import TradeWOC from '../components/tradeWOC';
import PositionTableWC from '../components/PositionTableWC';
import TradingFormWC from '../components/TradingFormWC';
// import './ConnectBroker.css'; // Import custom CSS for additional styling

export default function TradeWindow() {
  const dispatch = useDispatch();
  const optionChainState = useSelector((state) => state.optionChain) || {};
  const { strikePrices, loading, error } = optionChainState;

  const [formData, setFormData] = useState({
    broker: '',
    exchange: 'NSE',
    segment: 'Options',
    symbol: 'NSE_INDEX|Nifty 50',
    expiryDate: '2024-12-19',
    callStrike: '',
    putStrike: '',
    quantity: '50',
    productType: 'Margin',
    orderType: 'Market',
    marketProtection: '10',
    positionType: 'F&O positions only'
  });

  const [positions, setPositions] = useState([]);
  const [message, setMessage] = useState('');
  const [netQty, setNetQty] = useState(0);
  const [mtm, setMtm] = useState(0.00);

  const [symbol, setSymbol] = useState('NSE_INDEX|Nifty 50');
  const [expiry, setExpiry] = useState('2024-12-19');
  const [expiryOptions, setExpiryOptions] = useState([]);

  const expiryDates = useMemo(() => {
    // Get current IST date
    const today = new Date();
    const istToday = new Date(today.getTime() + (5.5 * 60 * 60 * 1000));
    
    // Generate upcoming Thursdays dynamically
    const getUpcomingThursdays = (count = 5) => {
      const dates = [];
      let current = new Date(istToday);
      
      // Include today if it's Thursday
      if (istToday.getDay() === 4) {
        const nextDay = new Date(istToday);
        nextDay.setDate(istToday.getDate() + 7);
        const isLastThursday = (nextDay.getMonth() !== istToday.getMonth());
        const dateStr = istToday.toISOString().split('T')[0];
        dates.push(dateStr);
      }
      
      // Get future Thursdays
      while (dates.length < count) {
        current.setDate(current.getDate() + 1);
        if (current.getDay() === 4) {
          const dateStr = current.toISOString().split('T')[0];
          dates.push(dateStr);
        }
      }
      return dates;
    };
    
    return {
      'NSE_INDEX|Nifty 50': getUpcomingThursdays(),
      'NSE_INDEX|Nifty Bank': getUpcomingThursdays(),
    };
  }, []);

  useEffect(() => {
    // Update expiry options based on selected symbol
    const options = expiryDates[symbol] || [];
    setExpiryOptions(options);
    const defaultExpiry = options[0] || ''; // Set default expiry to the first option
    setExpiry(defaultExpiry);
    setFormData(prev => ({ ...prev, expiryDate: defaultExpiry })); // Update formData with the first expiry date
  }, [symbol, expiryDates]);

  useEffect(() => {
    // Fetch option chain data when the component mounts or when symbol/expiryDate changes
    dispatch(fetchOptionChain({ symbol: formData.symbol, expiry: formData.expiryDate }));
  }, [dispatch, formData.symbol, formData.expiryDate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBuyCall = () => {
    if (!formData.broker) {
      setMessage('Please select broker to trade');
      return;
    }
    const newPosition = {
      symbolName: `${formData.symbol} ${formData.callStrike} CE`,
      netQty: formData.quantity,
      avgPrice: '24340.85',
      ltp: '24340.85',
      pnl: '0.00'
    };
    setPositions([...positions, newPosition]);
    setMessage('Buy Call order placed successfully');
  };

  const handleSellCall = () => {
    if (!formData.broker) {
      setMessage('Please select broker to trade');
      return;
    }
    setMessage('Sell Call order placed successfully');
  };

  const handleClosePositions = () => {
    setPositions([]);
    setMessage('All positions closed');
  };

  const handleCancelOrders = () => {
    setMessage('All orders cancelled');
  };

  return (
    <>
      {loading && <Alert variant="info">Loading...</Alert>}
      {error && (
        <Alert variant="danger">
          {error.error || 'An error occurred'}
          {error.details && <div>{error.details}</div>}
        </Alert>
      )}

      {message && (
        <Alert variant={message.includes('Please select') ? 'danger' : 'success'} className="mb-4">
          {message}
        </Alert>
      )}
    
    <Container fluid className="p-3">
    <Row>
    <Col>
      
      <TradingFormWC/>
     </Col>

      <Col md={4}>
          <TradeWOC/>
        </Col>
    </Row>

      {/* Positions Table */}
      <Row>
        <Col>
          <PositionTableWC/>
        </Col>
      </Row>
    </Container>
    </>
  );
}